(function (factory)
{
	//if (typeof define === "function" && define.amd)
	//	define(["jquery", "lib/jquery.jssor/jssor.core", "lib/jquery.jssor/jssor.utils", "lib/jquery.jssor/jssor.slider"], factory);
	//else
	//	factory(jQuery);

	if (typeof define === "function" && define.amd)
		define('jquery.jssor',["jquery", ".lib/jquery.jssor/jssor.slider.min"], factory);
	else
		factory(jQuery);

}(function ($)
{
	"use strict";

	$(function () {
		$("[data-jssor]").each(function() {
			if (typeof ($JssorSlider$) == "function") {
				var $element = $(this);
				var $progressContainer = $element.find("[data-jssor-progress='true'] > div");
				var elementId = $element.attr("id");
				var interval = parseInt($(this).attr("data-jssor")) | 5000;
				var slideDuration = 1700;
				var easing = $JssorEasing$.$EaseInOutCubic;

				if (!elementId)
					throw "Slider container must have an \"Id\" attribute.";

				var _CaptionTransitions = [];
				_CaptionTransitions["CLIP|L"] = { $Duration: 600, $Clip: 1, $Easing: $JssorEasing$.$EaseInOutCubic };
				_CaptionTransitions["RTT|10"] = { $Duration: 600, $Zoom: 11, $Rotate: true, $Easing: { $Zoom: $JssorEasing$.$EaseInExpo, $Opacity: $JssorEasing$.$EaseLinear, $Rotate: $JssorEasing$.$EaseInExpo }, $Opacity: 2, $Round: { $Rotate: 0.8 } };
				_CaptionTransitions["ZMF|10"] = { $Duration: 600, $Zoom: 11, $Easing: { $Zoom: $JssorEasing$.$EaseInExpo, $Opacity: $JssorEasing$.$EaseLinear }, $Opacity: 2 };
				_CaptionTransitions["FLTTR|R"] = { $Duration: 600, $ScaleHorizontal: 0.2, $ScaleVertical: 0.1, $Opacity: 2, $Round: { $Top: 1.3 } };

				var slider = new $JssorSlider$(elementId, {
					$AutoPlay: true,
					$SlideDuration: slideDuration,
					$PauseOnHover: 0,
					$AutoPlayInterval: interval,
					$SlideEasing: easing,
					$FillMode: 2,
					$BulletNavigatorOptions: {
						$Class: $JssorBulletNavigator$,
						$ChanceToShow: 2,
						$AutoCenter: 1,
						$Steps: 1,
						$SpacingX: 8,
						$Orientation: 1
					},
					$CaptionSliderOptions: {
						$Class: $JssorCaptionSlider$, //[Required] Class to create instance to animate caption
						$CaptionTransitions: _CaptionTransitions, //[Required] An array of caption transitions to play caption, see caption transition section at jssor slideshow transition builder
						$PlayInMode: 1, //[Optional] 0 None (no play), 1 Chain (goes after main slide), 3 Chain Flatten (goes after main slide and flatten all caption animations), default value is 1
						$PlayOutMode: 3 //[Optional] 0 None (no play), 1 Chain (goes before main slide), 3 Chain Flatten (goes before main slide and flatten all caption animations), default value is 1
					}
				});


				slider.$On($JssorSlider$.$EVT_LOAD_END, function () {
					$element.prev().hide();
					$element.show();

				});

				slider.$On($JssorSlider$.$EVT_DRAG_START, function ()
				{
					stopAnimation($progressContainer);
				});

				slider.$On($JssorSlider$.$EVT_DRAG_START, function () {
					stopAnimation($progressContainer);
				});

				slider.$On($JssorSlider$.$EVT_DRAG_END, function () {
					startResetAnimation($progressContainer, slideDuration);
				});


				slider.$On($JssorSlider$.$EVT_PARK, function ()
				{
					startFullWidthAnimation($progressContainer, interval);
				});

				slider.$On($JssorSlider$.$EVT_PROGRESS_CHANGE, function (slideIndex, progress, progressBegin, idleBegin, idleEnd, progressEnd) {
					if (progress == progressEnd) {
						startResetAnimation($progressContainer, slideDuration);
					}
				});

				scaleSlider(slider, $element);
				$(window).on("resize", function ()
				{
					scaleSlider(slider, $element);
				});

				startFullWidthAnimation($progressContainer, interval);
				$(".slider-loading").hide();
				$(".slider-progress").show();
				$("#home-slider").show();
			}
			else
				throw "Jssor Slider not loaded.";

			function startFullWidthAnimation(element, timer) {
				element.animate({ width: 0 }, 0)
					.stop()
					.clearQueue()
					.animate({ width: "100%" }, timer);
			}

			function startResetAnimation(element, timer) {
				element.stop()
					.clearQueue()
					.animate({ width: 0 }, timer);
			}

			function stopAnimation(element) {
				element.stop()
					.clearQueue();
			}

			function scaleSlider(sliderControl, element) {
				var parentWidth = element.parent().width();
				if (parentWidth) {
					var $navigator = element.find(".slider-navigator");
					var $captions = element.find(".slider-caption.visible-xs");
					$navigator.css("left", Math.round(parentWidth / 2 - $navigator.width()/2) + "px");
					sliderControl.$SetScaleWidth(parentWidth);
					$captions.css("width", parentWidth+"px");
				}
			}
		});
	});
}));
